import {
  IUseCreateBranch,
  useCreateBranch,
} from "../../common/branch/branch";

export const useCreateBranchCaller = (): IUseCreateBranch => {
  const {
    onSubmit,
    formValue,
    setFormValue,
    registerGeneral,
    handleSubmitGeneral,
    errorsGeneral,
    registerAddress,
    handleSubmitAddress,
    unRegisterAddress,
    errorsAddress,
    appendAddress,
    addressFields,
    addressRemove,
    loading,
  } = useCreateBranch();

  return {
    onSubmit,
    formValue,
    setFormValue,
    registerGeneral,
    handleSubmitGeneral,
    errorsGeneral,
    registerAddress,
    handleSubmitAddress,
    unRegisterAddress,
    errorsAddress,
    appendAddress,
    addressFields,
    addressRemove,
    loading,
  };
};
